import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { EventManagerPlugin } from '@angular/platform-browser';

@Injectable()
export class CheckInvalidEventPlugin extends EventManagerPlugin {
  constructor(
    // eslint-disable-next-line @angular-eslint/prefer-inject
    @Inject(PLATFORM_ID) private platformId: Object,
    // eslint-disable-next-line @angular-eslint/prefer-inject
    @Inject(DOCUMENT) doc: any,
  ) {
    super(doc);
  }

  supports(eventName: string): boolean {
    return eventName.endsWith('.checkinvalid');
  }

  addEventListener(element: HTMLElement, eventName: string, handler: Function): Function {
    if (!isPlatformBrowser(this.platformId)) {
      return () => {};
    }

    const realEventName = eventName.slice(0, -'.checkinvalid'.length);

    const outsideHandler = (event: Event, ...args: any[]) => {
      const ng = (window as any).ng;
      if (!ng) {
        handler(event, ...args);
        return;
      }

      const directives = ng.getDirectives(element) ?? [];
      const formDirective = directives.find((dir: any) => dir instanceof FormGroupDirective) as
        | FormGroupDirective
        | undefined;

      if (!formDirective) {
        handler(event, ...args);
        return;
      }

      const formGroup = formDirective.form;

      if (formGroup instanceof FormGroup && formGroup.invalid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        formGroup.markAllAsTouched();
        return;
      }

      handler(event, ...args);
    };

    return this.manager.addEventListener(element, realEventName, outsideHandler);
  }
}
